import { hasInvalidCharsInProjectName } from './hasInvalidCharsInProjectName';

export function validateAnalyticsReportName(reportName, statNames) {
    if (!reportName) {
        return 'Enter report name';
    }

    if (!reportName.replace(/\s/g, '').length) {
        return 'Report name cannot contain only space characters';
    }

    if (!reportName.replace(/\./g, '').length) {
        return 'Report name cannot contain only "." characters';
    }

    if (hasInvalidCharsInProjectName(reportName)) {
        return 'Report name can contain only ASCII alphanumeric characters and "-.:())"';
    }

    if (statNames.filter(name => name.toLowerCase() === reportName.toLowerCase()).length) {
        return 'Report with this name already exists';
    }
    return null;
}